import React from 'react';
import { FaBrain, FaHeartbeat, FaRobot } from 'react-icons/fa';

function Services() {
  const services = [
    {
      icon: <FaRobot />,
      title: 'AI Automation Pipelines',
      description: 'Streamline operations with custom pipeline design, integration, and data governance - efficiency, cost savings, and error reduction. EU/GDPR compliance supported.',
      cta: { text: 'Request a Consultation', href: '#contact' }
    },
    {
      icon: <FaHeartbeat />,
      title: 'Healthcare Analytics & Wearables',
      description: 'Unlock clinical and wellness insights from wearable and clinical data using proprietary ML/DL models. Predictive modeling, personalized insights, and GDPR/HIPAA readiness.',
      cta: { text: 'Learn More About Our Health Solutions', href: '#contact' }
    },
    {
      icon: <FaBrain />,
      title: 'Consultancy & Strategic Partnerships',
      description: 'Expert guidance on AI strategy, feasibility studies, R&D collaboration, and technology roadmaps - turning research into monetizable solutions.',
      cta: { text: 'Discuss Your Project', href: '#contact' }
    }
  ];

  return (
    <section id="services" style={{ 
      textAlign: 'center',
      background: 'transparent',
      padding: '80px 20px',
      margin: '0 auto',
      maxWidth: '1200px'
    }}>
      <h2 style={{ marginBottom: '12px' }}>What We Do</h2>
      <p style={{
        fontSize: '1.05rem',
        color: 'var(--text-secondary)',
        maxWidth: '900px',
        margin: '0 auto 24px',
        lineHeight: '1.6',
        fontWeight: 500
      }}>
        Applied Intelligence, Automation, and Data Strategy - tailored pipelines, compliant analytics,
        and strategic partnerships to accelerate value from your data.
      </p>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '18px',
        marginBottom: '36px',
        flexWrap: 'wrap'
      }}>
        <div style={{ padding: '8px 12px', background: 'rgba(6,182,212,0.12)', borderRadius: '999px', color: '#e2e8f0', border: '1px solid rgba(6,182,212,0.25)' }}>AI Automation</div>
        <div style={{ padding: '8px 12px', background: 'rgba(6,182,212,0.12)', borderRadius: '999px', color: '#e2e8f0', border: '1px solid rgba(6,182,212,0.25)' }}>Healthcare Analytics</div>
        <div style={{ padding: '8px 12px', background: 'rgba(6,182,212,0.12)', borderRadius: '999px', color: '#e2e8f0', border: '1px solid rgba(6,182,212,0.25)' }}>Consulting & Partnership</div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '30px',
        marginTop: '10px'
      }} className="services-grid">
        {services.map((service, index) => (
          <div 
            key={index}
            className="glass-card service-card"
            style={{
              padding: '36px 26px',
              textAlign: 'left',
              animation: `slideInUp 0.6s ease-out ${index * 0.1}s both`,
              cursor: 'default',
              transition: 'all 0.3s ease'
            }}
          >
            <div className="service-icon-wrap" style={{
              fontSize: '34px',
              marginBottom: '18px'
            }}>
              {service.icon}
            </div>
            
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '12px'
            }}>
              {service.title}
            </h3>
            
            <p className="service-description" style={{
              fontSize: '0.98rem',
              color: '#4a5568',
              lineHeight: '1.6',
              marginBottom: '18px'
            }}>
              {service.description}
            </p>

            <a href={service.cta.href} className="service-cta" target="_self" rel="noopener noreferrer">{service.cta.text}</a>
          </div>
        ))}
      </div>

      {/* Company metrics kept for credibility */}
      <div className="glass-card" style={{
        marginTop: '60px',
        padding: '36px',
        background: 'rgba(15, 23, 42, 0.56)',
        border: '1px solid rgba(148,163,184,0.22)',
        animation: 'slideInUp 0.8s ease-out 0.5s both'
      }}>
        <h3 style={{
          fontSize: '1.4rem',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '20px'
        }}>
          Proven Results & Growth
        </h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '24px',
          marginTop: '20px'
        }}>
          {[
            { metric: 'Efficiency Gain', value: '80%', description: 'Typical reduction in manual workload via automation' },
            { metric: 'Partners', value: '3', description: 'Institutions' },
            { metric: 'Data Points', value: '1M+', description: 'Processed monthly' },
            { metric: 'Pilot-to-POC Conversion', value: '60%', description: 'Average conversion rate' }
          ].map((item, index) => (
            <div key={index} style={{
              textAlign: 'center',
              padding: '18px',
              border: '1px solid rgba(148,163,184,0.22)',
              borderRadius: '8px',
              background: 'rgba(15,23,42,0.52)'
            }}>
              <div style={{
                fontSize: '1.9rem',
                fontWeight: '600',
                color: 'var(--text-primary)',
                marginBottom: '6px'
              }}>
                {item.value}
              </div>
              <div style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: 'var(--text-secondary)',
                marginBottom: '4px'
              }}>
                {item.metric}
              </div>
              <div style={{
                fontSize: '0.9rem',
                color: 'var(--muted)'
              }}>
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
